import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createLead = (email, source = "schedule_gate") =>
  axios.post(`${API}/leads`, { email, source });

export const subscribeNewsletter = (email, name = "", program_interest = "", marketing_consent = false) =>
  axios.post(`${API}/newsletter`, { email, name, program_interest, marketing_consent });

export const sendContact = (payload) =>
  axios.post(`${API}/contact`, payload);

export const bookTrial = (payload) =>
  axios.post(`${API}/trial-bookings`, payload);

export const sendChat = (session_id, message) =>
  axios.post(`${API}/chat`, { session_id, message });

export const submitChatLead = (payload) =>
  axios.post(`${API}/chat-leads`, payload);

export const registerTryout = (payload) =>
  axios.post(`${API}/tryout-registrations`, payload);

export const confirmTryoutPayment = (id) =>
  axios.post(`${API}/tryout-registrations/${id}/payment-sent`);

export const adminConfirmTryout = (id) =>
  axios.post(`${API}/admin/tryouts/${id}/confirm`, null, { withCredentials: true });

export const adminUpdateLeadStatus = (collection, id, status) =>
  axios.patch(`${API}/admin/lead-status`, { collection, id, status }, { withCredentials: true });

export const adminUpdateLeadNote = (collection, id, note) =>
  axios.patch(`${API}/admin/lead-note`, { collection, id, note }, { withCredentials: true });

export const fetchAdminOverview = () =>
  axios.get(`${API}/admin/overview`, { withCredentials: true });

export const authExchangeSession = (session_id) =>
  axios.post(`${API}/auth/session`, { session_id }, { withCredentials: true });

export const authMe = () => axios.get(`${API}/auth/me`, { withCredentials: true });

export const authLogout = () => axios.post(`${API}/auth/logout`, null, { withCredentials: true });

export const ebookUrl = `${API}/ebook`;
